export default __webpack_public_path__ + "static/1836-2404e3f03ab8a3a78786e37ae072a923.gif";